import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
  padding: ${({ theme }) => `0 ${theme.spacings.m}`};
  background-color: ${({ theme }) => theme.colors.neutral[100]};
  overflow: auto;
  width: 100%;
  max-width: calc(1280px + ${({ theme }) => theme.spacings.m} * 2);
  margin: 0 auto;
`;
